__turbopack_context__.v({
  "container": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__container",
  "hero-not-visible": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__hero-not-visible",
  "img-container": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__img-container",
  "logo": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__logo",
  "main": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__main",
  "mega-menu": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__mega-menu",
  "search-input": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__search-input",
  "skip-link": "CoreGlobalNavigationHeader-module-scss-module__5gveoa__skip-link",
});
